import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: false,
  isViewer: false,
  currentPageAccessLevel: {
    canRead: false,
    canWrite: false,
    canApprove: false,
    canViewAll: false,
    canAdmin: false,
  },
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setLoginFlag: (state, action) => {
      state.isAuthenticated = action.payload;
    },
    setIsViewer: (state, action) => {
      state.isViewer = action.payload;
    },
    setCurrentPageAccessLevel: (state, action) => {
      state.currentPageAccessLevel = action.payload;
    },
    logOutUser: (state) => {
      return initialState;
    },
  },
});

export const {
  setLoginFlag,
  logOutUser,
  setIsViewer,
  setCurrentPageAccessLevel,
} = authSlice.actions;

export default authSlice.reducer;
